// extracted by mini-css-extract-plugin
export default {"card":"_4-z"};